module.exports = __webpack_public_path__ + "img/noOrder.231d95b2.png";